import { ConsumerUnit } from 'consumerUnits/model/consumerUnit';
import { Cooperative } from 'cooperatives/models/cooperative';
import { CooperativeMember } from 'cooperatives/models/cooperativeMember';
import { EconomyReport } from 'economyReport/model/economyReport';
import { GenerationUnit } from 'generationUnits/models/generationUnit';
import { CommercialAgreement } from 'commercialAgreements/models/commercialAgreement';
import { ConsumerUnitBillData } from 'powerDistributionUnits/powerDistributionUnitBillData/consumerUnitBillData/models/consumerUnitBillData';

export type ChargeId = number;

export enum ChargeStatus {
  PAYED = 'PAYED',
  OPENED = 'OPENED',
  QUEUED = 'QUEUED',
  OVERDUE = 'OVERDUE',
  PENDING = 'PENDING',
  CANCELED = 'CANCELED',
  DEFAULTER = 'DEFAULTER',
}

export enum ChargePaymentMethods {
  PIX = 'PIX',
  CREDIT = 'CREDIT',
  BANK_SLIP = 'BANK_SLIP',
}

export interface Charges {
  id: ChargeId;
  consumerUnit: ConsumerUnit;
  cooperative: Cooperative;
  cooperativeMember: CooperativeMember;
  economyReport?: EconomyReport;
  generationUnit: GenerationUnit;
  comercialAgreement: CommercialAgreement;
  powerDistributionUnitBillData: ConsumerUnitBillData;
  chargeDueDate: string;
  chargeInterest: string;
  chargeTotalPaid: string;
  chargeInvoiceUrl: string;
  chargeTotalBilled: string;
  chargePaymentDate: string;
  chargeCreatedDate: string;
  chargeTotalCharged: string;
  chargeAppTotalFees: string;
  chargeStatus: ChargeStatus;
  chargeCooperativeTotalValue: string;
  chargeGenerationUnitTotalValue: string;
  chargePaymentMethod: ChargePaymentMethods;
  chargeGenerationUnitOemTotalValue: string;
  chargeCooperativeSubscriptionValue: string;
  chargeGenerationUnitRealStateTotalValue: string;
  chargeGenerationUnitEquipmentRentTotalValue: string;
}
